import React from "react";
import {useTranslation} from "react-i18next";
import ConfirmationModal from "../../../components/ui/ConfirmationModal";
import {Status} from "../../../models/enums";
import {useProjectDetailContext} from "../providers/ProjectDetailProvider";

/**
 * Prompts the user to migrate takeoff drawings from another company when the backend reports
 * that a matching takeoff exists under a different company_id for the same simpro build.
 * Mounted inside {@link ProjectDetailProvider} so it fires on every entry path.
 */
const MigrationConfirmationModal: React.FC = () => {
	const {t} = useTranslation();
	const {projectDetails} = useProjectDetailContext();
	const {
		project,
		migrationStatus,
		migrateFromOtherCompany,
		dismissedMigrationForProjectId,
		dismissMigrationPrompt,
	} = projectDetails;

	const shouldPrompt = !!project
		&& !!project.migrationAvailable
		&& !project.hasDrawings
		&& dismissedMigrationForProjectId !== project.id;

	if (!shouldPrompt || !project) return null;

	return (
		<ConfirmationModal
			isOpen={true}
			isLoading={migrationStatus === Status.LOADING}
			title={t("projects.details.migration.title")}
			text={t("projects.details.migration.message")}
			confirmationButtonLabel={t("projects.details.migration.confirmButton")}
			onConfirm={() => {
				migrateFromOtherCompany(project.id).then();
			}}
			onClose={() => {
				dismissMigrationPrompt(project.id);
			}}
		/>
	);
};

export default MigrationConfirmationModal;
